import { TransformedSuperGridColDef } from '@aleph/shared-components';
import { startCase } from 'lodash';
import { RedditLevel } from 'wb-reddit/src/app/routes/superGrid/utils';
import { EditableCallbackParams, ICellRendererParams } from 'ag-grid-community';

export const editableOnThisLevel = (params: EditableCallbackParams | ICellRendererParams): boolean => {
	const colDef = params.colDef as TransformedSuperGridColDef<RedditLevel>;

	if (
		!params?.data?.externalId
        && !params?.data?.hasErrors
        && params.data?.id
        && !params.colDef?.field?.startsWith('creative')
	) {
		return false;
	}

	return colDef?.level === params.data?.level
		&& !params?.data?.isCreate && !params?.data?.isExistingCreate
		&& (!params.context?.isInCreation || !params.data?.id);
};

export const editableOnLevel = (level: RedditLevel) => (params: EditableCallbackParams): boolean => level === params.data?.level
		&& !params?.data?.isCreate && !params?.data?.isExistingCreate
		&& (!params.context?.isInCreation || !params.data?.id);

export const getOptionsFromEnum = (
	options: Record<string, string>,
	capitalize = true,
) => Object.keys(options).filter(option => option !== 'Unknown').map((option: string) => ({
	value: options?.[option] as string,
	label: capitalize ? startCase(option) : option,
}));
